
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Page } from "@/types/page";
import { PlatformSelector } from "./PlatformSelector";
import { PositionSelector } from "./PositionSelector";
import { RotationTimeControl } from "./RotationTimeControl";
import ContentEditorSelector from "./ContentEditorSelector";
import { usePageContext } from "@/hooks/usePageContext";

interface PageEditorFormProps {
  editedPage: Page;
  handleTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleContentChange: (field: string, value: any) => void;
  handlePlatformChange: (platform: any) => void;
  handlePositionChange: (position: any) => void;
  handleRotationTimeChange: (value: number[]) => void;
  handleRotationTimeInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleUseCustomRotationTimeChange: (checked: boolean) => void;
  handleSavePage: () => void;
  onCancel: () => void;
}

const PageEditorForm: React.FC<PageEditorFormProps> = ({
  editedPage,
  handleTitleChange,
  handleContentChange,
  handlePlatformChange,
  handlePositionChange,
  handleRotationTimeChange,
  handleRotationTimeInputChange,
  handleUseCustomRotationTimeChange,
  handleSavePage,
  onCancel,
}) => {
  const { rotationInterval } = usePageContext();
  
  return (
    <Card>
      <CardContent className="pt-6 space-y-6">
        <div>
          <label className="block mb-2">כותרת</label>
          <Input 
            value={editedPage.title} 
            onChange={handleTitleChange} 
            placeholder="כותרת הדף"
          />
        </div>
        
        <div className="flex flex-wrap gap-6">
          {/* Platform Selection */}
          <PlatformSelector 
            platform={editedPage.platform || "both"} 
            onPlatformChange={handlePlatformChange} 
          />
          
          {/* Position Selection */}
          <PositionSelector 
            position={editedPage.position || "left"} 
            onPositionChange={handlePositionChange} 
          />

          {/* Rotation Time Setting */}
          <RotationTimeControl
            rotationTime={editedPage.rotationTimeMs || 10}
            useCustomRotationTime={editedPage.useCustomRotationTime || false}
            globalRotationTime={rotationInterval}
            onRotationTimeChange={handleRotationTimeChange}
            onRotationTimeInputChange={handleRotationTimeInputChange}
            onUseCustomRotationTimeChange={handleUseCustomRotationTimeChange}
          />
        </div>
        
        <ContentEditorSelector
          pageType={editedPage.type}
          content={editedPage.content}
          onContentChange={handleContentChange}
        />
      </CardContent>
      <CardFooter className="flex justify-end space-x-2">
        <Button variant="outline" onClick={onCancel}>
          ביטול
        </Button>
        <Button onClick={handleSavePage}>
          שמור
        </Button>
      </CardFooter>
    </Card>
  );
};

export default PageEditorForm;
